module.exports = __webpack_public_path__ + "static/media/plus.25fd1e1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plus.svg
// module id = 2085
// module chunks = 33